import React from 'react';
import {
  Box,
  Collapse,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Typography,
  Chip,
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import { format } from 'date-fns';
import { EmployeeRow, EmployeeTableCell, HeaderSubTitle } from './styles/plannedVsActualReportStyles';
import { TasksForEmployee } from './TasksForEmployee';
import { formatSecondesToHourMinute } from '../../../../utils/formatTime';
import Iconify from '../../../../components/iconify';
import { StatusChip } from './StatusChip';

export const EmployeeView = ({ project, isExpanded, expandedEmployees, onToggleEmployee, startDate, endDate }) => (
  <TableRow>
    <TableCell style={{ padding: 0 }} colSpan={6}>
      <Collapse in={isExpanded}>
        <Box sx={{ pl: 6 }}>
          <Table size="small" sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '50px' }} />
                <TableCell sx={{ width: '40%' }}>Employee Name</TableCell>
                <TableCell sx={{ width: '10%' }} align="right">
                  Progress
                </TableCell>
                <TableCell sx={{ width: '25%' }} align="right">
                  Consumed Efforts
                  {startDate && endDate && (
                    <HeaderSubTitle>
                      {format(new Date(startDate), 'dd-MM-yyyy')} to {format(new Date(endDate), 'dd-MM-yyyy')}
                    </HeaderSubTitle>
                  )}
                </TableCell>
                <TableCell sx={{ width: '25%' }} align="right">
                  Planned Efforts
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {project.members?.map((member) => (
                <React.Fragment key={member.id}>
                  <EmployeeRow>
                    <TableCell sx={{ pl: 1 }}>
                      <IconButton size="small" onClick={() => onToggleEmployee(member.id)}>
                        {expandedEmployees.has(member.id) ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                      </IconButton>
                    </TableCell>
                    <EmployeeTableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Iconify icon="clarity:employee-solid" />
                        <Typography noWrap>{member?.userName}</Typography>
                        <StatusChip
                          status={member.tasks?.length || 0}
                          type="count"
                          label={`${member.tasks?.length} tasks`}
                        />
                      </Box>
                    </EmployeeTableCell>
                    <EmployeeTableCell align="right">
                      <StatusChip
                        status={Math.round((member.totalConsumedSeconds / member.totalPlannedSeconds) * 100) || 0}
                        type="progress"
                      />
                    </EmployeeTableCell>
                    <EmployeeTableCell align="right">
                      {formatSecondesToHourMinute(member.totalConsumedSeconds)}
                    </EmployeeTableCell>
                    <EmployeeTableCell align="right">
                      {formatSecondesToHourMinute(member.totalPlannedSeconds)}
                    </EmployeeTableCell>
                  </EmployeeRow>
                  {expandedEmployees.has(member.id) && (
                    <TasksForEmployee member={member} startDate={startDate} endDate={endDate} />
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Collapse>
    </TableCell>
  </TableRow>
);
